const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "stretch",
    // height: "100vh",
    width: "100%",
    // minHeight:'100vh',
    position: "relative",
    // overflow: "hidden",
    // padding: "1.5rem",
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    // gap: "20px",
    boxSizing: "border-box",
    // height: "100%",
    width: "100%",
    // maxWidth: "1440px",
    margin: "0 auto",
    // padding: "1.5rem",
  },
  logo: {
    // width: "100%",
    height: "48px",
    // borderRadius: "50%",
    // boxShadow: "2px 2px 4px 0px #0000000D",
    // marginBottom: "20px",
    // fontFamily: "Thunder",
    // textTransform: "uppercase",
    // fontSize: "26px",
    // display: "flex",
    // gap: "10px",
    // alignItems: "center",
    // justifyContent: "center",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    // alignItems: "center",
    color: "white",
    // width: "100%",
    // zIndex: 99,
    padding: "12px 100px",

    background: "rgba(255, 255, 255, 0.04)",
    backdropFilter: " blur(1px)",
    /* Note: backdrop-filter has minimal browser support */
  },
  tabContainer: {
    display: "flex",
    gap: "40px",
    justifyContent: "flex-end",
    color: "#FFFFFF99",
  },
  topTabs: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
  tabs: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "8px",
    borderRadius: "12px",
    cursor: "pointer",
    // backgroundColor: "#FFFFFF0A",
    color: "#292929",
    fontSize: "16px",
    "&:hover": {
      color: "#4D6CF6",
    },
    zIndex: 999999,
  },

  socialLinks: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    marginLeft: "2rem",
  },
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    backgroundColor: "#FFFFFF99",
    borderRadius: "50%",
    padding: "4px",
    color: "black",
    cursor: "pointer",
  },
};
export default styles;
